<template>
<div>
	<i class="fas fa-upload"></i>
    <a class="btn btn-success mr-4" @click="toggleShow">Upload image</a>	
	    <upload-image field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
			@src-file-set="imageUploaded"
            v-model="show"
            lang-type="en"
	    	:width="100"
	    	:height="100"	        		    		    	
	    	img-format="png">
        </upload-image>
	    <img :src="parentImgDataUrl">               
</div>       
</template>
<script>
import UploadImage from 'vue-image-crop-upload';
import axios from 'axios';
import links from '../../store/modules/links/links';
export default {
	data() {
        return {
            show: false,                    
			imgDataUrl: '',
			selectedImageName: null
        }
	},
	props: {
		parentImgDataUrl: { 
			type: String,     		
      		required: true
    	}
	}, 

    components: {
		'upload-image': UploadImage	
    },
    methods: {
        toggleShow() {
			this.show = !this.show;
        },
        // Get uploaded image data
		imageUploaded(fileName, fileType, fileSize) {
			this.selectedImageName = fileName;
			// console.log(fileName, fileType, fileSize);
        },
        // Successfully crop selected image
		cropSuccess(imgDataUrl, field){
			console.log('-------- crop success --------');           
            // Transform base64 image to png
            var file = this.dataURLtoFile(imgDataUrl, this.selectedImageName);
            // console.log(file);
            // Save created image to media_objects in database 
			const accessToken = localStorage.getItem("access-token");                        
			let data = new FormData();
			data.append('file', file);
			  const headers = {
				"Content-Type": "multipart/form-data",
				"Authorization": "Bearer " + accessToken, 
        	};        
        	return axios.post(links.API_HOST + "/media_objects", data, {
        	    headers: headers
        	}).then((response) => {
				console.log(response);
				this.imgDataUrl = links.API_HOST + response.data.contentUrl;				
				this.$emit('imageUrlChanged', response.data);				
			}).catch((error) => {
				this.imgDataUrl = imgDataUrl;
				this.$emit('imageUrlChanged', this.imgDataUrl);
			});		

        },
        cropUploadSuccess(jsonData, field){
			console.log('-------- upload success --------');
			// console.log(jsonData);
			// console.log('field: ' + field);
		},		
		cropUploadFail(status, field){
			console.log('-------- upload fail --------');
			// console.log(status);
			// console.log('field: ' + field);
        },	
        dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(','),
        	mime = arr[0].match(/:(.*?);/)[1],
        	bstr = atob(arr[1]), 
        	n = bstr.length, 
        	u8arr = new Uint8Array(n);
        	while(n--){
        	    u8arr[n] = bstr.charCodeAt(n);
        	}
        	return new File([u8arr], filename, {type:mime});
		},
    },
}
</script>


// WEBPACK FOOTER //
// src/components/image-uploader/ImageUploader.vue